import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import React from 'react'

import { useDevice } from '../../../../hooks/use.device'
import { useNewsStyles } from './newsStyles'
import { NewsProps } from './types'
import { useNews } from './use.news'

export default function NewsComponent({ newsList }: NewsProps): JSX.Element {
  const { history, redirectToNew } = useNews()
  const { device } = useDevice()
  const classes = useNewsStyles()

  return (
    <Box className={classes.main}>
      <Typography variant="h3" className={classes.title}>
        Notícias e informações
      </Typography>

      <Box className={classes.newsContainer}>
        <Box
          className={classes.topContainerNews}
          style={{
            flexWrap: device === 'desktop' ? 'nowrap' : 'wrap',
            justifyContent: device === 'desktop' ? 'space-between' : 'center',
          }}
        >
          {newsList.results.slice(0, 3).map((news) => (
            <Box
              key={news.id}
              className={classes.topNews}
              onClick={() => redirectToNew(news.slug)}
            >
              <img
                className={classes.image}
                src={news.imagem_destaque_url}
                alt={news.titulo}
              />
              <Box sx={{ width: '100%' }}>
                <Typography variant="h4" className={classes.topNewsTitle}>
                  {news.titulo}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
        {device === 'desktop' && (
          <Grid container spacing={3}>
            {newsList.results.slice(3, 9).map((news) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={news.id}
                className={classes.bottonNews}
                onClick={() => redirectToNew(news.slug)}
              >
                <img
                  src={news.imagem_destaque_url}
                  className={classes.bottonImage}
                  alt={news.titulo}
                />
                <Typography variant="body1" className={classes.bottonNewsTitle}>
                  {news.titulo}
                </Typography>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>

      <Button
        className={classes.button}
        variant="contained"
        onClick={() => history.push('/noticias')}
      >
        <Typography className={classes.textButton}>
          Todas as notícias
        </Typography>
      </Button>
    </Box>
  )
}
